import { action, makeObservable, observable } from 'mobx';
import type { OrientationPresetKind } from '../interfaces';
import type { IOrientationPreset } from './viewEntity/view.entity.ts';

export class OrientationPreset implements IOrientationPreset {
  @observable public label: string;

  public descriptor: string;

  public kind: OrientationPresetKind;

  public constructor(label: string, descriptor: string, kind: OrientationPresetKind) {
    this.label = label;
    this.descriptor = descriptor;
    this.kind = kind;
    makeObservable(this);
  }

  @action
  public setLabel(label: string): void {
    this.label = label;
  }
}
